import Link from "../../Link";

const Symfony = () => {
    return (
        <div>
            <Link url="https://campus.open-bootcamp.com/cursos/20" title={"OpenBootcamp Symfony(PHP)"} />
        </div>
    );
}

export default Symfony;